// BlogPost.jsx
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import './blog-section.css';

export const BlogPost = () => {
  const { slug } = useParams();
  const [blog, setBlog] = useState(null);

  const blogs = {
    "solar-panel-subsidy-delhi-ncr-guide-2023": {
      id: 1,
      title: "Solar Panel Subsidy in Delhi NCR - Complete Guide 2023",
      content: `
        <h1>Solar Panel Subsidy in Delhi NCR - Complete Guide 2023</h1>
        <p>Installing solar panels in Delhi, Noida, and Ghaziabad has become more affordable than ever with government subsidies. 
        Under the PM Surya Ghar Muft Bijli Yojana, residents can avail up to 40% subsidy on rooftop solar installations.</p>
        
        <h2>Eligibility Criteria</h2>
        <ul>
          <li>Residential properties in Delhi NCR region</li>
          <li>Ownership documents of the property</li>
          <li>Valid electricity connection</li>
          <li>Minimum 10 sq.m shadow-free roof area</li>
        </ul>
        
        <h2>Subsidy Structure</h2>
        <table>
          <tr>
            <th>System Capacity</th>
            <th>Subsidy Amount</th>
          </tr>
          <tr>
            <td>1kW to 3kW</td>
            <td>₹18,000 per kW</td>
          </tr>
          <tr>
            <td>Above 3kW</td>
            <td>₹9,000 per kW</td>
          </tr>
        </table>
        
        <h2>How to Apply</h2>
        <p>Visit the <a href="https://solarrooftop.gov.in" target="_blank">National Portal for Rooftop Solar</a> and follow these steps:</p>
        <ol>
          <li>Register with your electricity consumer number</li>
          <li>Upload required documents</li>
          <li>Select from empaneled vendors like TechnoSun Enterprises</li>
          <li>Get approval within 15 working days</li>
        </ol>
      `,
      excerpt: "Learn how to avail up to 40% subsidy on solar installations in Delhi, Noida & Ghaziabad under central government schemes.",
      image: "https://images.unsplash.com/photo-1509391366360-2e959784a276?ixlib=rb-1.2.1&auto=format&fit=crop&w=1200&q=80",
      date: "June 15, 2023",
      author: "Solar Expert Team",
      tags: ["Solar Subsidy", "Delhi Solar", "Free Solar Scheme", "Solar NCR"]
    },
    "rooftop-solar-installation-cost-savings-analysis": {
      id: 2,
      title: "Rooftop Solar Installation: Cost vs Savings Analysis",
      content: `
        <h1>Rooftop Solar Installation: Cost vs Savings Analysis</h1>
        <p>Investing in a rooftop solar system is a significant decision. This analysis breaks down the costs and potential savings for a typical 5kW installation in the NCR region.</p>
        
        <h2>Initial Investment</h2>
        <p>For a standard 5kW system in Delhi NCR:</p>
        <ul>
          <li>Base cost: ₹2,75,000</li>
          <li>Less subsidy (40% up to 3kW, 20% for remaining capacity): ₹78,000</li>
          <li>Net cost after subsidy: ₹1,97,000</li>
        </ul>
        
        <h2>Annual Savings</h2>
        <p>With net metering benefits:</p>
        <ul>
          <li>Annual electricity generation: 7,300 units (approx)</li>
          <li>Average electricity rate: ₹8 per unit</li>
          <li>Annual savings: ₹58,400</li>
        </ul>
        
        <h2>Return on Investment</h2>
        <p>Break-even point: Approximately 3.4 years</p>
        <p>25-year savings (system lifetime): ₹14,60,000</p>
        
        <h2>Additional Benefits</h2>
        <ul>
          <li>Property value increase</li>
          <li>Protection against electricity price hikes</li>
          <li>Carbon footprint reduction: 5 tons CO2 per year</li>
        </ul>
      `,
      excerpt: "Detailed breakdown of 5kW solar system costs in NCR region and how much you can save with net metering benefits.",
      image: "https://images.unsplash.com/photo-1508514177221-188b1cf16e9d?ixlib=rb-1.2.1&auto=format&fit=crop&w=1200&q=80",
      date: "May 28, 2023",
      author: "Solar Expert Team",
      tags: ["Solar ROI", "Solar Noida", "Solar Cost"]
    },
    "pm-surya-ghar-muft-bijli-yojana-application-guide": {
      id: 3,
      title: "PM Surya Ghar Muft Bijli Yojana - How to Apply Online",
      content: `
        <h1>PM Surya Ghar Muft Bijli Yojana - How to Apply Online</h1>
        <p>The PM Surya Ghar Muft Bijli Yojana is a transformative scheme providing free solar electricity to residential consumers in Uttar Pradesh. Here's how to apply.</p>
        
        <h2>Scheme Benefits</h2>
        <ul>
          <li>Financial assistance of up to ₹78,000 for residential solar installations</li>
          <li>Zero-interest loans available for remaining amount</li>
          <li>Net metering facility to sell excess power back to the grid</li>
        </ul>
        
        <h2>Step-by-Step Application Process</h2>
        <ol>
          <li>Visit the official portal: pm-surya-ghar.gov.in</li>
          <li>Register using your mobile number and electricity consumer number</li>
          <li>Complete the online application form with property details</li>
          <li>Upload required documents:
            <ul>
              <li>Property ownership proof</li>
              <li>Latest electricity bill</li>
              <li>ID proof (Aadhaar/PAN)</li>
              <li>Photographs of installation site</li>
            </ul>
          </li>
          <li>Choose from empaneled vendors in your region</li>
          <li>Submit the application and note your reference number</li>
        </ol>
        
        <h2>Post-Application Process</h2>
        <ol>
          <li>Technical feasibility assessment within 7 days</li>
          <li>Approval notification via SMS/email</li>
          <li>Installation by selected vendor</li>
          <li>Inspection and commissioning</li>
          <li>Subsidy disbursal to your linked bank account</li>
        </ol>
        
        <h2>Important Deadlines</h2>
        <p>Applications for the current financial year close on December 31, 2023. Early applicants will receive priority processing.</p>
      `,
      excerpt: "Step-by-step guide to register for free solar electricity scheme for residential consumers in Uttar Pradesh.",
      image: "https://images.unsplash.com/photo-1541167760496-1628856ab772?ixlib=rb-1.2.1&auto=format&fit=crop&w=1200&q=80",
      date: "April 10, 2023",
      author: "Solar Expert Team",
      tags: ["Free Solar", "Govt Scheme", "UP Solar"]
    }
  };

  useEffect(() => {
    setBlog(blogs[slug]);
    // Update meta tags for SEO
    if (blogs[slug]) {
      document.title = `${blogs[slug].title} | TechnoSun Enterprises`;
      document.querySelector('meta[name="description"]').setAttribute("content", blogs[slug].excerpt);
    }
  }, [slug]);

  if (!blog) return <div>Loading...</div>;

  return (
    <div className="blog-post-page">
      <div className="container">
        <article className="blog-post">
          <header className="post-header">
            <h1>{blog.title}</h1>
            <div className="post-meta">
              <span className="date">{blog.date}</span>
              <span className="author">By {blog.author}</span>
            </div>
          </header>
          
          <div className="post-image">
            <img src={blog.image} alt={blog.title} />
          </div>
          
          <div 
            className="post-content" 
            dangerouslySetInnerHTML={{ __html: blog.content }} 
          />
          
          <div className="post-tags">
            {blog.tags.map(tag => (
              <span key={tag} className="tag">{tag}</span>
            ))}
          </div>
        </article>
      </div>
    </div>
  );
};